export const STRINGS = {
  actionItem: 'ACTION ITEM',
};
